<template>
  <Form ref="formCustom"
    :model="formCustom"
    :rules="ruleCustom"
    :label-width="58"
    :class="{ 'yjh-edit-account' : editAccount }">
    <FormItem v-if="!isEdit" label="登录名" prop="accountName" :error="formObjError.accountName">
      <Input type="text" v-model.trim="formCustom.accountName" :maxlength="15" placeholder="请输入登录名" autocomplete="off"></Input>
      <p class="hint">3-15位字符，可由中文、英文、数字及“_”、“-”组成</p>
    </FormItem>
    <div v-if="isEdit" class="ivu-form-item" style="margin-bottom: 10px;margin-top: -10px">
      <label class="ivu-form-item-label" style="width: 58px">登录名</label>
      <div style="margin-left: 58px;height: 32px;line-height: 32px" class="ivu-form-item-content">
        <span>{{formCustom.accountName}}</span>
      </div>
    </div>
    <FormItem label="密码" prop="passwd">
      <Input type="password" v-model.trim="formCustom.passwd" autocomplete="off" :maxlength="20" placeholder="请输入密码"></Input>
      <p class="hint">6-20位字符，可由英文及数字组成</p>
    </FormItem>
    <FormItem label="确认密码" prop="passwdCheck">
      <Input type="password" v-model.trim="formCustom.passwdCheck" autocomplete="off" :maxlength="20" placeholder="请输入确认密码"></Input>
      <p class="hint">6-20位字符，可由英文及数字组成</p>
    </FormItem>
    <FormItem label="权限组" prop="grouping">
      <Select v-model="formCustom.grouping" placeholder="请选择权限组">
        <Option v-for="(key, index) in selectVlu" :key="index" :value="key.gid">{{key.gname}}</Option>
      </Select>
      <p class="hint">如果还未设置，请先建立权限组后再添加账号</p>
    </FormItem>
    <FormItem>
      <Button type="primary" @click="handleSubmit('formCustom')">确认提交</Button>
    </FormItem>
  </Form>
</template>
<script>
import { getJurisdictionList } from '@/api/app'
export default {
  name: 'account-form',
  props: ['isEdit', 'accountName', 'formObjError'],
  components: {},
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('登录名不能为空'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'))
      } else if (value.length < 6) {
        callback(new Error('密码最短为6位，最长为20位'))
      } else {
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('确认密码不能为空'))
      } else if (value !== this.formCustom.passwd && value !== '') {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    const vlidateEditPassWord = (rule, value, callback) => {
      if (value) {
        if (value.length < 6) {
          callback(new Error('密码最短为6位，最长为20位'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const editValidatePassCheck = (rule, value, callback) => {
      if (value && value.length < 6) {
        callback(new Error('确认密码最短为6位，最长为20位'))
      }
      if (value !== this.formCustom.passwd) {
        callback(new Error('两次输入密码不一致'))
      }
      callback()
    }
    const validateGrouping = (rule, value, callback) => {
      const gidArr = this.selectVlu.map(item => Number(item.gid))
      if (value === '') {
        callback(new Error('权限组不能为空'))
      } else if (!gidArr.includes(Number(value))) {
        callback(new Error('权限组不能为空'))
      } else {
        callback()
      }
    }
    return {
      formCustom: {
        accountName: '',
        passwd: '',
        passwdCheck: '',
        grouping: '',
        adminId: ''
      },
      editAccount: true,
      selectVlu: [],
      ruleCustom: {},
      editAuleCustom: {
        passwd: [
          { validator: vlidateEditPassWord, trigger: 'blur' }
        ],
        passwdCheck: [
          { validator: editValidatePassCheck, trigger: 'blur' }
        ],
        grouping: [
          { validator: validateGrouping, trigger: 'blur' }
        ]
      },
      addAuleCustom: {
        accountName: [
          { validator: validateName, trigger: 'blur' }
        ],
        passwd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        passwdCheck: [
          { validator: validatePassCheck, trigger: 'blur' }
        ],
        grouping: [
          { validator: validateGrouping, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  methods: {
    // 提交
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('accountWay', this.formCustom)
        }
      })
    },
    // 获取权限列表下拉值
    gitJurisdiction() {
      getJurisdictionList().then(res => {
        if (res.code === 0) {
          this.selectVlu = res.result.data
        } else {
          this.$Message.info(res.msg)
        }
      })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.formCustom.accountName = this.$route.query.name
      this.formCustom.adminId = this.$route.query.id
      this.formCustom.grouping = Number(this.$route.query.gid)
    }
    this.gitJurisdiction()
  },
  created() {
    if (this.$route.name === 'editAccount') {
      this.editAccount = true
      this.ruleCustom = this.editAuleCustom
    } else {
      this.editAccount = false
      this.ruleCustom = this.addAuleCustom
    }
  }
}
</script>
<style lang="scss">
  .account {
    padding: 10px 0 10px 215px;
    .hint {
      height:12px;
      font-size:12px;
      font-weight:400;
      color:rgba(181,194,208,1);
      line-height:12px;
      margin-top: 10px;
    }
    .ivu-form .ivu-form-item-label {
      padding: 0 0;
      line-height: 32px;
      font {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        vertical-align: initial!important;
      }
      &:before {
         content: "*";
         display: inline-block;
         line-height: 1;
         font-size: 12px;
         color: #ed4014;
       }
    }
    .ivu-form.yjh-edit-account .ivu-form-item {
      &:nth-child(2){
        .ivu-form-item-label{
          &:before {
             content: '';
          }
        }
      }
      &:nth-child(3){
        .ivu-form-item-label{
          &:before {
             content: '';
          }
        }
      }
    }
    .ivu-input {
      width: 210px;
      height: 32px;
      line-height: 32px;
      background:rgba(255,255,255,1);
      font-size: 12px;
      border-radius:4px;
      padding: 10px 10px;
      border:1px solid rgba(210,220,230,1);
      &:focus{
         border:1px solid rgba(24,129,220,1);
         outline:none!important;
         box-shadow: none;
       }
    }
    .ivu-form-item-error{
      .ivu-input {
        font-size: 12px;
        border:1px solid rgba(210,220,230,1);
        &:focus{
         border:1px solid rgba(24,129,220,1);
         outline:none!important;
         box-shadow: none;
       }
      }
    }
    .ivu-select {
      font-size: 12px;
      width: 210px;
      height: 32px;
      line-height: 32px;
    }
    .ivu-select-single .ivu-select-selection {
      height: 32px;
      line-height: 32px;
    }
    .ivu-select-dropdown {
      width: 210px;
    }
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      height: 32px;
      line-height: 32px;
    }
    .ivu-form-item {
      margin-bottom: 20px;
    }
    .ivu-form-item:last-child {
      margin-bottom: 0;
      height: 28px;
      line-height: 28px;
      min-height: 28px;
      margin-top: 30px;
    }
    .ivu-form-item-error-tip {
      top: 12px;
      padding: 0 0;
      position: absolute;
      left: 230px;
      font-size:12px;
      font-weight:400;
      color:rgba(220,24,24,1);
      line-height:12px;
    }
    .ivu-form-item-content {
     line-height: normal;
      font-size: 12px;
      padding-left: 10px;
    }
    .ivu-btn>span {
      vertical-align: bottom;
    }
  }
</style>
